import * as ActionTypes from './ActionTypes';
import { assign } from '../../shared/Assign';

export default function profileReducer(state: any = {}, action: { type: string; result: any }) {
    switch (action.type) {
        case ActionTypes.LOAD_PROFILE_SUCCESS:
            let newState = assign({}, state);
            newState = assign({}, action.result);
            return newState;

        default:
            return state;
    }
}
